import * as React from "react";
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import {
    Box
} from '@mui/material';
const CustomNumberField = (props) => {
    const { source } = props;
    const record = useRecordContext(props);
    const sourceList = source.split(".");
    let finalRecord = record
    if (finalRecord != null) {
        if (sourceList.length > 1) {
            for (let item of sourceList) {
                if (finalRecord != null) {
                    finalRecord = finalRecord[item]
                }
            }
        } else {
            finalRecord = record[source]
        }
        return <Box sx={{ display: "flex", justifyContent: "center", borderRadius: "50%", padding: "5px 10px", width: "fit-content" }}> {finalRecord}</Box>;
    } else {
        return <span>-</span>;
    }
}

CustomNumberField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default CustomNumberField;